<div class="d-flex align-items-center divider-end">
    @if (selectedTenant$ | ngrxPush; as selectedTenant) {
        <ng-select
            class="tenant-select"
            bindLabel="name"
            bindValue="code"
            data-cy="kmo-ui-tenant-selected"
            [clearable]="false"
            [items]="tenants ?? []"
            [ngModel]="selectedTenant?.code"
            (ngModelChange)="onTenantChange($event)"
        ></ng-select>
    }
</div>
